module.exports = __webpack_public_path__ + "img/notifications.48a56aea.svg";